import React, { FC, useEffect, useState } from "react";
import { Input, FormFeedback, FormGroup, Label } from "reactstrap";

interface PasswordInputProps {
  label?: string;
  name: string;
  value: string;
  setValue: (name: string, value: string) => void;
  setError?: (name: string, error: boolean) => void;
  placeholder?: string;
  errorMessage?: string;
  error?: boolean;
  required?: boolean;
  maxChars?: number;
  disabled?: boolean;
  validation?: (value: string) => boolean;
  showPassword?: boolean;
  design?: "flex" | "default";
  passCol?: string;
}

const PasswordInput: FC<PasswordInputProps> = ({
  label,
  name,
  value,
  setValue,
  setError,
  placeholder = "",
  errorMessage = "Invalid input",
  error = false,
  required = false,
  maxChars,
  disabled,
  validation = () => true,
  showPassword,
  design = "default",
  passCol,
}) => {
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = e.target;

    const charCount = inputValue.replace(/\s/g, "").length;

    if (maxChars && charCount > maxChars) {
      return;
    }

    setValue(name, inputValue);
    if (setError) {
      setError(name, false);
    }
  };

  const handleBlur = () => {
    if (!validation(value) && setError) {
      setError(name, true);
    }
  };
  const flexClass = design === "flex" && windowWidth > 768 ? "d-flex align-items-center" : "";
  const labelWidthClass = design === "flex" && windowWidth > 768 ? "col-3" : "";
  const passColClass = windowWidth > 768 ? passCol : "";

  return (
    <FormGroup className={flexClass}>
      {label && (
        <Label for={name} className={`${design === "flex" ? "mr-5 " : ""}${labelWidthClass}`}>
          {label}
          {required && <span className="text-danger ml-2">*</span>}
        </Label>
      )}
      <div className={passColClass}>
        {error && <FormFeedback className="d-block mt-1">{errorMessage}</FormFeedback>}
        <div className="form-input position-relative">
          <Input
            id={name}
            name={name}
            type={showPassword ? "text" : "password"}
            value={value} 
            onChange={handleInputChange}
            onBlur={handleBlur}
            placeholder={placeholder}
            disabled={disabled}
            invalid={error}
            autoComplete="on"
          />
        </div>
      </div>
    </FormGroup>
  );
};

export default PasswordInput;
